import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-likes-heart-icon",
  "use": "icon-likes-heart-icon-usage",
  "viewBox": "0 0 74 74",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 74 74\" id=\"icon-likes-heart-icon\">\r\n  <rect x=\"0\" y=\"0\" width=\"74\" height=\"74\" rx=\"16\" fill=\"#f9e6e8\" />\r\n  <rect x=\"21\" y=\"21\" width=\"32\" height=\"32\" rx=\"10\" fill=\"#f56c6c\" />\r\n  <path fill=\"#ffffff\" d=\"M37 44.2c-.4 0-.8-.1-1.1-.4l-6-5.8c-3.2-3.1-4.8-5-4.8-7.5 0-3.7 2.9-6.6 6.7-6.6 2.1 0 4 1 5.2 2.5 1.2-1.6 3.1-2.5 5.2-2.5 3.8 0 6.7 2.9 6.7 6.6 0 2.5-1.6 4.4-4.8 7.5l-6 5.8c-.3.3-.7.4-1.1.4z\" transform=\"translate(37 37) scale(0.72) translate(-37 -37)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/likes-heart-icon.svg
// module id = jZvI
// module chunks = 115